
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/noleggio-sci",
      function () {
        return require("private-next-pages/[region]/[resort]/noleggio-sci.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/noleggio-sci"])
      });
    }
  